import { Grid } from "@jsq/ds/core";
import { getProfileName } from "../../Profiles/utils";
import { usePaymentInstructions } from "../PaymentInstructionsContext";
import { BankDetailsProfileType, BeneficiaryDetails } from "../types";
import { columnDefinition, defaultColDef, gridOptions } from "./gridConfig";

type BeneficiaryDetailsProps = {
  caseId: number;
  paymentDataProfiles: BankDetailsProfileType[];
  readonly: boolean;
  paymentPrefId?: number;
};

const BeneficiarySummary = ({
  caseId,
  paymentDataProfiles,
  readonly,
  paymentPrefId,
}: BeneficiaryDetailsProps) => {
  const { caseType } = usePaymentInstructions();

  const rowData: BeneficiaryDetails[] = paymentDataProfiles.map(
    (profile: BankDetailsProfileType) => {
      return {
        paymentBeneficiary: {
          id: profile?.paymentAccounts?.[0]?.id ?? 0,
          name: getProfileName(profile),
        },
        screening: {
          caseId: caseId,
          profileId: profile?.id ?? 0,
          screeningRecord: profile?.screeningRecord?.result || null,
        },
        readonly,
        paymentPrefId,
      };
    },
  );

  const getDisplayRowData = (): BeneficiaryDetails[] => {
    if (rowData.length > 0) {
      return rowData;
    }

    return [{ paymentBeneficiary: undefined, screening: undefined, readonly, paymentPrefId }];
  };

  return (
    <Grid
      gridOptions={gridOptions}
      columnDefs={columnDefinition}
      defaultColDef={defaultColDef}
      rowData={getDisplayRowData()}
      context={{ caseType }}
    />
  );
};

export default BeneficiarySummary;
